export const QUICK_ACTION_TOOLTIP_MESSAGE =
  'This creates a customizable copy of the core questionnaire.';

export const QUICK_ACTION_TOOLTIP_SLOT_PROPS = {
  tooltip: {
    sx: {
      maxWidth: 260,
      bgcolor: '#D9F6FF',
      color: '#101828',
      fontFamily: 'Inter, sans-serif',
      fontWeight: 500,
      fontSize: { xs: '12px', sm: '13px' },
      lineHeight: { xs: '16px', sm: '20px' },
      textAlign: 'center',
      px: { xs: 1.5, sm: 2 },
      py: { xs: 1, sm: 1.25 },
      borderRadius: '6px',
      boxShadow: '0px 12px 32px rgba(16, 24, 40, 0.16)',
    },
  },
  arrow: {
    sx: {
      color: '#D9F6FF',
    },
  },
} as const;
